module.exports = __webpack_public_path__ + "img/hyjmd2-img5.7b5c0cfd.png";